import React, { Fragment } from 'react';
import createSvgIcon from '../createSvgIcon';

const TextFile = () => {
  const Icon = createSvgIcon({
    title: 'TextFile',
    width: '32px',
    height: '32px',
    viewBox: '0 0 32 32',
    content: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("path", {
      d: "M24,32H6a3,3,0,0,1-3-3V3A3,3,0,0,1,6,0H21.41L27,5.59V29A3,3,0,0,1,24,32ZM6,2A1,1,0,0,0,5,3V29a1,1,0,0,0,1,1H24a1,1,0,0,0,1-1V6.41L20.59,2Z"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "8",
      y: "10",
      width: "6",
      height: "3",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "8",
      y: "15",
      width: "14",
      height: "3",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("rect", {
      x: "8",
      y: "20",
      width: "12",
      height: "3",
      fill: "#e60000"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M23,10H19a2,2,0,0,1-2-2V4h2V8h4Z"
    }))
  });
  return /*#__PURE__*/React.createElement(Icon, null);
};

export default TextFile;